import { toast, type ToastItem } from 'react-toastify'

/**
 * Espelha todo toast no `console` do navegador.
 *
 * O toast some em poucos segundos, e mensagem de erro do backend é justamente o
 * que mais precisa ser lida depois: em teste automatizado (a extensão do Chrome
 * lê o console, não a tela) e no suporte, onde o usuário só consegue mandar print
 * do console depois que o aviso já sumiu.
 *
 * Fica no `toast.onChange` — a API global do react-toastify — em vez de em cada
 * chamada: são mais de 2.000 `toast.error` espalhados pelo app, e um wrapper
 * exigiria trocar todos (e lembrar de usá-lo em todo código novo).
 *
 * Prefixo `[toast]` fixo para dar o que filtrar: `pattern: "\[toast\]"`.
 */
export function installToastConsoleMirror(): void {
    toast.onChange((payload: ToastItem) => {
        // Só a criação interessa: 'updated' repete a mensagem a cada re-render e
        // 'removed' avisa que sumiu, o que não ajuda a diagnosticar nada.
        if (payload.status !== 'added') return

        const text =
            typeof payload.content === 'string'
                ? payload.content
                : // Conteúdo em JSX (toast com markup): não dá para extrair o texto
                  // sem renderizar, então registramos ao menos o tipo e o id.
                  '[conteúdo em JSX]'

        const line = `[toast:${payload.type ?? 'default'}] ${text}`

        if (payload.type === 'error') {
            console.error(line)
        } else if (payload.type === 'warning') {
            console.warn(line)
        } else {
            console.info(line)
        }
    })
}
